import common from './en/common';

import home from './en/pages/home';
import order from './en/pages/order';

import services from './en/components/services';
import reservationBar from './en/components/reservationBar';
import servicesFilter from './en/components/servicesFilter';
import passengerDetails from './en/components/passengerDetails';
import orderDetails from './en/components/orderDetails';
import paymentDetails from './en/components/paymentDetails';
import createAccount from './en/components/createAccount';
import profileSettings from './en/components/profileSettings';
import toolbarNavigation from './en/components/toolbarNavigation';
import shuttles from './en/components/shuttles';
import tripsFilter from './en/components/tripsFilter';
import confirmCodePopup from './en/components/confirmCodePopup';

import taxelco from './en/clients/taxelco';
import moovex from './en/clients/moovex';
import summary from './en/pages/summary';
import contact from './en/pages/contact';
import trips from './en/pages/trips';
import cancelTrip from './en/pages/cancelTrip';

const pages = {
  home,
  order,
  summary,
  contact,
  trips,
  cancelTrip,
};

const components = {
  services,
  reservationBar,
  servicesFilter,
  passengerDetails,
  orderDetails,
  paymentDetails,
  createAccount,
  profileSettings,
  toolbarNavigation,
  shuttles,
  tripsFilter,
  confirmCodePopup,
};

const clients = {
  taxelco,
  moovex,
};

export default { ...components, ...pages, ...clients , common};
